import React, { useContext, useState, useEffect } from "react";
import { ChatContext } from "../contexts/ChatContext";
import { AuthContext } from "../contexts/AuthContext";
import { ThemeContext } from "../contexts/ThemeContext";
import "../styles/CustomDrawer.css";
import { Trash, Moon, Sun, Power, ChatLeftText, KeyFill, List } from "react-bootstrap-icons";
import logo from "../assets/images/logo.png";
import { LanguageContext } from "../contexts/LanguageContext"; 
import { useNavigate } from "react-router-dom";

const CustomDrawer = () => {
  const {
    conversations,
    loadMessagesForConversation,
    startConversation,
    deleteConversation,
    deleteAllConversations,
    fetchConversations,
    isLoading,
    errorMessage,
  } = useContext(ChatContext);
  const { toggleDarkMode, isDarkMode } = useContext(ThemeContext);
  const { logout } = useContext(AuthContext); // useContext'i burada çağır
  const { translations } = useContext(LanguageContext); 

  const [loadingNewChat, setLoadingNewChat] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadConversations = async () => {
      try {
        await fetchConversations();
      } catch (error) {
        console.error("Error fetching conversations:", error);
      }
    };
    loadConversations();
  }, [fetchConversations]);

  const handleConversationClick = async (conversationId) => {
    try {
      await loadMessagesForConversation(conversationId);
    } catch (error) {
      console.error("Failed to load messages:", error);
    }
  };

  const handleNewChat = async () => {
    setLoadingNewChat(true);
    try {
      const newConversation = await startConversation(translations.newChatTitle);
      // Yeni sohbet başlatıldığında otomatik olarak sohbeti yükle
      await handleConversationClick(newConversation.conversation_id);
      
    } catch (error) {
      console.error("Error starting new chat:", error);
    } finally {
      setLoadingNewChat(false);
    }
  };

  const handleDeleteConversation = async (conversationId) => {
    try {
      await deleteConversation(conversationId);
    } catch (error) {
      console.error("Error deleting conversation:", error);
    }
  };

  const handleClearHistory = async () => {
    try {
      await deleteAllConversations();
    } catch (error) {
      console.error("Error clearing conversation history:", error);
    }
  };

  const handleLogout = async () => {
    const response = await logout(); // logout fonksiyonunu çağır
    if (response.success) {
      console.log("User logged out");
      navigate("/chat/login")
    } else {
      console.error("Logout failed:", response.message);
    }
  };

  const handleChangePassword = () => {
    navigate("/chat/change-password"); // Change Password sayfasına yönlendirme
  };


  return (
    <>
      {/* Mobil Cihazlarda Menü Açma Butonu */}
      <button
        className={`btn ${isDarkMode ? "btn-dark" : "btn-light"} d-lg-none shadow-sm p-3`}
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasMenu"
        aria-controls="offcanvasMenu"
        aria-label="Toggle menu"
      >
        <i className="bi bi-list" style={{ fontSize: "1.5rem" }}></i>
      </button>

    {/* Offcanvas Menü - Mobil Ekranlar İçin */}
    <div
      className={`offcanvas offcanvas-start ${isDarkMode ? "dark-mode" : ""}`}
      tabIndex="-1"
      id="offcanvasMenu"
      aria-labelledby="offcanvasMenuLabel"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="offcanvasMenuLabel">
          <img src={logo} alt="Logo" className="drawer-logo img-fluid" />
        </h5>
        <button
          type="button"
          className={`btn-close ${isDarkMode ? "btn-close-white" : ""}`}
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body d-flex flex-column justify-content-between">
        {/* Menü içerikleri */}
        <div>

          <button
            onClick={handleNewChat}
            disabled={loadingNewChat}
            className="new-chat-btn w-100 mb-3"
          >
            {loadingNewChat ? translations.loading : translations.newChat}
          </button>
          <ul className="conversation-list">
            {errorMessage && <p className="error-message">{errorMessage}</p>}
            {false ? (
              <li>{translations.loadingConversations}</li>
            ) : conversations.length > 0 ? (
              conversations.map((conversation) => (
                <li
                  key={conversation.conversation_id}
                  className="conversation-item"
                  onClick={() => handleConversationClick(conversation.conversation_id)}
                >
                  {/* Burada data-bs-dismiss ekleniyor */}
                  <button 
                    className="chat-button w-100 text-start"
                    data-bs-dismiss="offcanvas"
                  >
                    <ChatLeftText /> {conversation.title}
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteConversation(conversation.conversation_id);
                    }}
                    className="delete-icon-btn"
                  >
                    <Trash />
                  </button>
                </li>
              ))
            ) : (
              <li>{translations.noConversations}</li>
            )}
          </ul>
        </div>

        {/* Menü Altındaki Diğer Butonlar */}
        <div className="mt-3 border-top pt-3">
         <button
            className="chat-button dark-mode-btn"
            onClick={toggleDarkMode}
          >
            {isDarkMode ? <Moon /> : <Sun />} {isDarkMode ? translations.lightMode : translations.darkMode}
          </button>
          <button
            className="chat-button change-password-btn w-100 mb-2"
            onClick={handleChangePassword}
          >
            <KeyFill /> {translations.changePassword}
          </button>
          <button
            className="chat-button logout-btn w-100 mb-2"
            onClick={handleLogout}
          >
            <Power /> {translations.logout}
          </button>
          <button
            className="chat-button clear-history-btn w-100"
            onClick={handleClearHistory}
          >
            <Trash style={{ color: isDarkMode ? "white" : "black" }} />{translations.clearHistory}
          </button>
        </div>
      </div>
    </div>

      {/* Sabit Menü - Tablet ve Büyük Ekranlar İçin */}
      <div
        className={`drawer-container d-none d-lg-flex ${isDarkMode ? "dark-mode" : ""}`}
      >
        
        <div className="drawer-header" align="center">
          <img src={logo} alt="Logo" className="drawer-logo img-fluid" />
          <hr className="drawer-divider" />
          <button
            onClick={handleNewChat}
            disabled={loadingNewChat}
            className="new-chat-btn"
          >
            {loadingNewChat ? translations.loading : translations.newChat}
          </button>
        </div>
        <div className="drawer-content">
          <ul className="conversation-list">
            {false ? (
              <li>{translations.loadingConversations}</li>
            ) : conversations.length > 0 ? (
              conversations.map((conversation) => (
                <li
                  key={conversation.conversation_id}
                  className="conversation-item"
                  onClick={() => handleConversationClick(conversation.conversation_id)}
                >
                  <button className="chat-button">
                    <ChatLeftText /> {conversation.title}
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteConversation(conversation.conversation_id);
                    }}
                    className="delete-icon-btn"
                  >
                     <Trash style={{ color: isDarkMode ? "white" : "black" }} />
                  </button>
                </li>
              ))
            ) : (
              <li>{translations.noConversations}</li>
            )}
          </ul>
        </div>
        <div className="drawer-footer">
        
          <button
            className="chat-button change-password-btn"
            onClick={handleChangePassword}
          >
            <KeyFill /> {translations.changePassword}
          </button>
          <button
            className="chat-button logout-btn"
            onClick={handleLogout}
          >
            <Power /> {translations.logout}
          </button>
          <button
            className="chat-button clear-history-btn"
            onClick={handleClearHistory}
          >
            <Trash /> {translations.clearHistory}
          </button>
        </div>
      </div>
    </>
  );
};

export default CustomDrawer;
